export const toggleCarbonDioxide = {
  ToggleCarbonDioxide: () => {
    function toggleCarbonDioxide({ onCompleted }) {
      onCompleted();
    }
    return [toggleCarbonDioxide, { loading: false }];
  },
};
